import React, { useState } from 'react';
import "./ValidationForm.css"; // Reutilizamos tus estilos bonitos

const ValidatedInput = ({ 
    label, 
    placeholder, 
    endpointId, 
    paramName, 
    validatorFunction, 
    isDisabled,
    onSuccess, 
    transformValue
}) => {
    const [value, setValue] = useState("");
    const [status, setStatus] = useState("idle"); // idle, loading, success, error
    const [errorMsg, setErrorMsg] = useState("");
    const [dataSummary, setDataSummary] = useState(null);
    
    // Nuevo estado para mostrar/ocultar la ficha técnica
    const [showDetails, setShowDetails] = useState(false);

    const handleValidate = async () => {
        if (!value) return;
        setStatus("loading");
        setErrorMsg("");
        setDataSummary(null);
        setShowDetails(false); // Ocultar detalles previos al revalidar

        // Si hay función de transformar, la usamos (ej: "google.com" -> "contact@google.com")
        // Si no, usamos el valor tal cual.
        const valueToSend = transformValue ? transformValue(value) : value;

        console.log(`[${label}] Enviando a API:`, valueToSend);

        try {
            const response = await fetch('/api-proxy', {
                method: 'POST',
                headers: {
                    'PublicApiKey': '8c9348d8-bac6-493d-95e4-26f68cfbe822',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idEndPoint: endpointId,
                    // CORRECCIÓN AQUÍ: Usamos valueToSend
                    params: [{ "name": paramName, "value": valueToSend }]
                })
            });

            const rawData = await response.json();
            console.log(`Respuesta API (${label}):`, rawData);

            const result = validatorFunction(rawData);

            if (result.isValid) {
                setStatus("success");
                setDataSummary(result.summary);
                if (onSuccess) onSuccess();
            } else {
                setStatus("error");
                setErrorMsg(result.message || "Dato inválido");
            }

        } catch (error) {
            console.error(error);
            setStatus("error");
            setErrorMsg("Error de conexión con el servicio.");
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !isDisabled) handleValidate();
    };

    return (
        <div className={`form_step_group ${isDisabled ? 'opacity_dimmed' : ''}`}>
            <label className="step_label">{label}</label>
            
            <div className="input_button_wrapper">
                <div className="step_input_container">
                    <input 
                        type="text" 
                        className={`custom_input ${status === 'error' ? 'input_error' : ''} ${status === 'success' ? 'input_success' : ''}`}
                        placeholder={placeholder}
                        value={value}
                        onChange={(e) => {
                            setValue(e.target.value);
                            if (status === 'error') setStatus('idle');
                        }}
                        onKeyDown={handleKeyDown}
                        disabled={isDisabled || status === 'loading'} 
                    />
                    <div className="step_status_icon">
                        {status === 'loading' && <div className="spinner"></div>}
                        {status === 'success' && <div className="check_mark">✔</div>}
                        {status === 'error' && <div className="error_mark">✖</div>}
                    </div>
                </div>
                
                {/* Botón Principal: Validar */}
                <button 
                    className="btn_validate"
                    onClick={handleValidate}
                    disabled={isDisabled || status === 'loading' || !value}
                >
                    {status === 'loading' ? 'Validando...' : 'Validar'}
                </button>

                {/* Botón Secundario: Ver Detalles (Solo si es Success) */}
                {status === 'success' && (
                    <button 
                        className="btn_ghost"
                        onClick={() => setShowDetails(!showDetails)}
                        title="Ver información extraída"
                    >
                        {showDetails ? 'Ocultar' : 'Ver Datos'}
                    </button>
                )}
            </div>

            {/* Mensaje de Error */}
            {status === 'error' && <p className="error_text">{errorMsg}</p>}

            {/* FICHA TÉCNICA (CARD DE DETALLES) */}
            {status === 'success' && showDetails && dataSummary && (
                <div className="data_details_card animate_fade_in">
                    <div className="details_header">
                        Información Verificada
                    </div>
                    <div className="details_grid">
                        {Object.entries(dataSummary).map(([key, val]) => (
                            <div key={key} className="detail_item">
                                <span className="detail_label">{key}:</span>
                                <span className="detail_value">{val}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ValidatedInput;